const lesAmisCollections = {
  bautizo: {
    eyebrow: "Bautizo",
    title: "Bautizo",
    text: "Modelos suaves y atemporales para los primeros momentos.",
    products: [
      ["Elenita", "Bautizo", "Ranita de ceremonia en algodón suave.", ["0-3M", "3-6M", "6-9M", "9-12M"]],
      ["Esther", "Bautizo", "Vestido delicado con acabado artesanal.", ["0-3M", "3-6M", "6-9M", "9-12M"]],
      ["Estefanía", "Bautizo", "Conjunto ceremonial de líneas clásicas.", ["0-3M", "3-6M", "6-9M", "9-12M"]],
      ["Cata", "Bautizo", "Pieza ligera para celebraciones familiares.", ["0-3M", "3-6M", "6-9M", "9-12M"]],
      ["Alfonso", "Bautizo", "Conjunto de niño con patrón cómodo.", ["0-3M", "3-6M", "6-9M", "9-12M"]],
      ["Carlos", "Bautizo", "Modelo sencillo con acabado cuidado.", ["0-3M", "3-6M", "6-9M", "9-12M"]],
    ],
  },
  "arras-ninos": {
    eyebrow: "Arras",
    title: "Arras niños",
    text: "Pantalones y camisas de arras con corte cómodo.",
    products: [
      ["Roman", "Arras niño · Pantalones", "Pantalón de arras con corte cómodo y acabado cuidado.", ["2", "4", "6", "8", "10", "12"]],
      ["Bruno", "Arras niño · Pantalones", "Pantalón de arras con corte cómodo y acabado cuidado.", ["2", "4", "6", "8", "10", "12"]],
      ["Mauro", "Arras niño · Pantalones", "Pantalón de arras con corte cómodo y acabado cuidado.", ["2", "4", "6", "8", "10", "12"]],
      ["Mario", "Arras niño · Camisas", "Camisa de arras en tejido suave para completar el conjunto.", ["2", "4", "6", "8", "10", "12"]],
      ["Pol", "Arras niño · Camisas", "Camisa de arras en tejido suave para completar el conjunto.", ["2", "4", "6", "8", "10", "12"]],
      ["Tristan", "Arras niño · Camisas", "Camisa de arras en tejido suave para completar el conjunto.", ["2", "4", "6", "8", "10", "12"]],
    ],
  },
  "arras-ninas": {
    eyebrow: "Arras",
    title: "Arras niñas",
    text: "Vestidos y accesorios delicados para ceremonia.",
    products: [
      ["Gina", "Arras niña · Vestidos", "Vestido de arras con confección local y detalle delicado.", ["2", "4", "6", "8", "10", "12"]],
      ["Julieta", "Arras niña · Vestidos", "Vestido de arras con confección local y detalle delicado.", ["2", "4", "6", "8", "10", "12"]],
      ["Maria", "Arras niña · Vestidos", "Vestido de arras con confección local y detalle delicado.", ["2", "4", "6", "8", "10", "12"]],
      ["Sandra", "Arras niña · Vestidos", "Vestido de arras con confección local y detalle delicado.", ["2", "4", "6", "8", "10", "12"]],
      ["Cludia", "Arras niña · Vestidos", "Vestido de arras con confección local y detalle delicado.", ["2", "4", "6", "8", "10", "12"]],
      ["Capota", "Arras · Accesorios", "Accesorio de ceremonia para completar el look de arras.", ["Única"]],
      ["Coronita", "Arras · Accesorios", "Accesorio de ceremonia para completar el look de arras.", ["Única"]],
      ["Pasador", "Arras · Accesorios", "Accesorio de ceremonia para completar el look de arras.", ["Única"]],
      ["Lazada", "Arras · Accesorios", "Accesorio de ceremonia para completar el look de arras.", ["Única"]],
    ],
  },
  "primera-comunion-ninas": {
    eyebrow: "Primera comunión",
    title: "Primera comunión niñas",
    text: "Vestidos de comunión y modelos especiales.",
    products: [
      ["Andrea", "Comunión niña", "Vestido de comunión con caída natural.", ["6", "8", "10", "12", "14"]],
      ["Gabi", "Comunión niña", "Diseño cómodo con detalles sutiles.", ["6", "8", "10", "12", "14"]],
      ["Sandra", "Comunión niña", "Línea editorial con tejidos suaves.", ["6", "8", "10", "12", "14"]],
      ["Inés", "Comunión niña", "Modelo romántico sin exceso.", ["6", "8", "10", "12", "14"]],
      ["Alejandra", "Comunión niña", "Vestido especial con acabado premium.", ["6", "8", "10", "12", "14"]],
      ["Mencía", "Comunión niña", "Patrón actual con confección local.", ["6", "8", "10", "12", "14"]],
      ["Pía", "Comunión niña", "Vestido luminoso para ceremonia.", ["6", "8", "10", "12", "14"]],
      ["Reyes", "Comunión niña", "Modelo elegante de edición cuidada.", ["6", "8", "10", "12", "14"]],
    ],
  },
  "primera-comunion-ninos": {
    eyebrow: "Primera comunión",
    title: "Primera comunión niños",
    text: "Americanas, camisas, pantalones y accesorios.",
    products: [
      ["Americanas", "Comunión niño", "Americana de ceremonia con estructura ligera.", ["6", "8", "10", "12", "14"]],
      ["Camisas", "Comunión niño", "Camisa blanca de ceremonia en algodón.", ["6", "8", "10", "12", "14"]],
      ["Pantalones", "Comunión niño", "Pantalón cómodo con corte limpio.", ["6", "8", "10", "12", "14"]],
      ["Corbatas", "Comunión niño", "Complemento de ceremonia en tonos suaves.", ["Única"]],
      ["Zapatos", "Comunión niño", "Zapato de ceremonia para completar el conjunto.", ["28", "30", "32", "34", "36"]],
    ],
  },
  colegios: {
    eyebrow: "Primera comunión",
    title: "Primera comunión colegios",
    text: "Uniformidad cuidada para centros y grupos.",
    products: [["Uniformidad de comunión", "Colegios", "Servicio para colegios con imagen coordinada y confección local.", ["Consulta"]]],
  },
};

const slugifyProduct = (value) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const getLesAmisProducts = () =>
  Object.entries(lesAmisCollections).flatMap(([collectionKey, collection]) =>
    collection.products.map(([name, category, description, sizes]) => ({
      collectionKey,
      collectionTitle: collection.title,
      slug: slugifyProduct(name),
      name,
      category,
      description,
      sizes,
      price: 1,
    })),
  );

window.lesAmisCollections = lesAmisCollections;
window.lesAmisProducts = getLesAmisProducts();
window.slugifyProduct = slugifyProduct;